import { getIsTriggeredCampaignType } from 'modules/campaigns/lib/utils';
import { CampaignType } from 'modules/domains/campaign';
import {
  BannerCampaignType,
  RandomlySplitVariations,
  SummaryCardWinner,
  experimentDetailsSummaryCardMap,
  experimentDetailsSummaryCardNoWinnerMap,
} from 'modules/experiments/constants';
import { ExperimentState } from 'modules/graphql';
import moment from 'moment';
import { BasePageExperimentVariantProperties } from '../types';

interface GetExperimentSummaryBannerDisplayItemsFromMappingProps {
  experimentState: ExperimentState;
  randomlySplitVariations: boolean;
  campaignType: CampaignType;
  variantWinnerType: SummaryCardWinner;
}
export const getExperimentSummaryBannerDisplayItemsFromMapping = ({
  experimentState,
  randomlySplitVariations,
  campaignType,
  variantWinnerType,
}: GetExperimentSummaryBannerDisplayItemsFromMappingProps) => {
  const isRandomlySplitVariations = randomlySplitVariations
    ? RandomlySplitVariations.True
    : RandomlySplitVariations.False;
  const isBlastOrTriggered = getIsTriggeredCampaignType(campaignType)
    ? BannerCampaignType.Triggered
    : BannerCampaignType.Blast;

  if (
    experimentState === ExperimentState.DRAFT ||
    experimentState === ExperimentState.READY ||
    experimentState === ExperimentState.CANCELLED ||
    experimentState === ExperimentState.ERRORED
  ) {
    return experimentDetailsSummaryCardNoWinnerMap[experimentState];
  } else if (experimentState === ExperimentState.FINISHED) {
    return experimentDetailsSummaryCardMap[isBlastOrTriggered][isRandomlySplitVariations][
      ExperimentState.FINISHED
    ][variantWinnerType];
  } else if (experimentState === ExperimentState.RUNNING) {
    return experimentDetailsSummaryCardMap[isBlastOrTriggered][isRandomlySplitVariations][
      ExperimentState.RUNNING
    ];
  } else if (experimentState === ExperimentState.WINNER_FOUND) {
    return experimentDetailsSummaryCardMap[isBlastOrTriggered][isRandomlySplitVariations][
      ExperimentState.WINNER_FOUND
    ][variantWinnerType];
  } else {
    return null;
  }
};

interface GetMinutesLeftInExperimentProps {
  testDurationInMinutes: number;
  startedAt: string;
}

export const getMinutesLeftInExperiment = ({
  testDurationInMinutes,
  startedAt,
}: GetMinutesLeftInExperimentProps): number => {
  const projectedExperimentEnd = moment(startedAt).add(testDurationInMinutes, 'minutes');
  const currentTime = moment();
  const minutesLeftInExperiment = projectedExperimentEnd.diff(currentTime, 'minutes');
  return minutesLeftInExperiment > 0 ? minutesLeftInExperiment : 0;
};

export const getMinutesRunInExperiment = (startedAt: string): number => {
  const experimentStartTime = moment(startedAt);
  const currentTime = moment();
  return currentTime.diff(experimentStartTime, 'minutes');
};

export const getStatusMappingIfWinnerVariationsExist = (
  variant?: BasePageExperimentVariantProperties,
) => {
  if (variant && variant.control) {
    return SummaryCardWinner.Control;
  } else if (variant && variant.control === false) {
    return SummaryCardWinner.Variant;
  } else {
    return SummaryCardWinner.None;
  }
};
